export const blockIconsHouseholdChildCareNew = (
	<span className='material-symbols-outlined'>child_care</span>
);
